import { useState } from 'react';
import { Badge } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  SearchRounded as SearchRoundedIcon,
  HomeRounded as HomeRoundedIcon,
  TodayRounded as TodayRoundedIcon,
  FolderOpenRounded as FolderOpenRoundedIcon,
  AssignmentTurnedInOutlined as AssignmentTurnedInOutlinedIcon,
  BarChartRounded as BarChartRoundedIcon,
  DashboardRounded as DashboardRoundedIcon,
  LaunchTwoTone as LaunchIcon,
  VpnKeyRounded as VpnKeyRoundedIcon,
  PersonRounded as PersonRoundedIcon,
  DialpadRounded as DialpadRoundedIcon,
} from '@material-ui/icons';
import { FEATURE } from '../../utils/feature';
import { VISITS_URL, VISITS_URL_V1 } from '../../constants/patientChart.constant';
import './styles.scss';

const hasFeature = FEATURE();

const StyledBadge = withStyles(() => ({
  badge: {
    color: 'var(--black)',
    background: 'var(--lighter-grey)'
  },
}))(Badge);

export const NavKey = {
  home: 'home',
  sv: 'scheduled-visits',
  ao: 'async-orders',
  pcm: 'phoenix-capital-management',
  tasks: 'tasks',
  reports: 'reports',
  so: 'search-orders',
  v1: 'version-1',
  changepass: 'change-password',
  changepin: 'change-pin',
  profile: 'profile',
};

export const SelectedNavItem = {
  key: NavKey.home,
};

export const NavItem = new Map([
  [NavKey.home, {
    key: NavKey.home,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <HomeRoundedIcon className='color-white' />
      </div>
    ),
    label: 'Home',
    url: VISITS_URL,
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.sv, {
    key: NavKey.sv,
    Icon: ({
      badgeCount = 0,
    }) => (
      <div className='flex align-items-center justify-content-center width-72'>
        <StyledBadge overlap='circular' badgeContent={badgeCount} max={99} color='primary'>
          <TodayRoundedIcon className='color-white' />
        </StyledBadge>
      </div>
    ),
    label: 'Scheduled Visits',
    url: '/scheduled-visits',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.ao, {
    key: NavKey.ao,
    Icon: ({
      badgeCount = 0,
    }) => (
      <div className='flex align-items-center justify-content-center width-72'>
        <StyledBadge overlap='circular' badgeContent={badgeCount} max={99} color='primary'>
          <FolderOpenRoundedIcon className='color-white' />
        </StyledBadge>
      </div>
    ),
    label: 'Asynchronous Orders',
    url: '/async-orders',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.tasks, {
    key: NavKey.tasks,
    Icon: ({
      badgeCount = 0,
    }) => (
      <div className='flex align-items-center justify-content-center width-72'>
        <StyledBadge overlap='circular' badgeContent={badgeCount} max={99} color='primary'>
          <AssignmentTurnedInOutlinedIcon className='color-white' />
        </StyledBadge>
      </div>
    ),
    label: 'Tasks',
    url: '/tasks',
    badgeCount: 0,
    onRoute: () => {},
    enabled: hasFeature.TASKS_TAB,
  }],
  [NavKey.reports, {
    key: NavKey.reports,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <BarChartRoundedIcon className='color-white' />
      </div>
    ),
    label: 'Reports',
    url: VISITS_URL,
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.so, {
    key: NavKey.so,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <SearchRoundedIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Search Orders',
    url: '/search-orders',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.pcm, {
    key: NavKey.pcm,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <DashboardRoundedIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Prescriber Portal',
    url: VISITS_URL,
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.v1, {
    key: NavKey.v1,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <LaunchIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Jump into version 1',
    url: VISITS_URL_V1,
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.changepass, {
    key: NavKey.changepass,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <VpnKeyRoundedIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Change Password',
    url: '/change-password',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.changepin, {
    key: NavKey.changepin,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <DialpadRoundedIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Change PIN',
    url: '/change-pin',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
  [NavKey.profile, {
    key: NavKey.profile,
    Icon: () => (
      <div className='flex align-items-center justify-content-center width-72'>
        <PersonRoundedIcon fontSize='medium' className='color-white' />
      </div>
    ),
    label: 'Profile',
    url: '/profile',
    badgeCount: 0,
    onRoute: () => {},
    enabled: true,
  }],
]);

/**
 * @param {string[]} keys
 * @returns {{
 *    key: string;
 *    Icon: React.JSX.Element;
 *    label: string;
 *    url: string;
 *    badgeCount: number;
 *    onRoute: () => void;
 *    enabled: boolean;
 * }[]}
 */
export const enabledNavItems = (keys = []) => {
  /**
   * @type {{
   *    key: string;
   *    Icon: React.JSX.Element;
   *    label: string;
   *    url: string;
   *    badgeCount: number;
   *    onRoute: () => void;
   *    enabled: boolean;
   * }[]}
   */
  const navItems = [];

  keys.forEach((key) => {
    const nav = NavItem.get(key);
    if (nav?.enabled) {
      navItems.push(nav);
    }
  });

  return navItems;
};

export const NavItems = enabledNavItems([
  NavKey.home,
  NavKey.sv,
  NavKey.ao,
  NavKey.tasks,
  NavKey.reports,
  NavKey.pcm,
  NavKey.so,
]);

export const BottomNavItems = enabledNavItems([
  NavKey.v1,
]);

const NavMode = {
  collapsed: 'min-width-72 max-width-72',
  expanded: 'min-width-260',
};

const MENU_HEIGHT = 56;

/**
 * 
 * @param {{
 *  items: NavItems;
 *  bottomItems: BottomNavItems;
 *  selectedItem: SelectedNavItem;
 * }} params 
 * @returns {React.JSX.Element}
 */
export const NavBar = ({
  items,
  bottomItems,
  selectedItem,
}) => {
  const [mode, setMode] = useState(NavMode.collapsed);

  const handleMouseEnter = () => {
    setMode(NavMode.expanded);
  };

  const handleMouseLeave = () => {
    setMode(NavMode.collapsed);
  };

  return (
    <div className={`patient-chart-nav-bar border-box overflow-hidden relative ${mode}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {
        items.map(({ key, Icon, label, url, badgeCount, onRoute: handleRoute = () => {}, }, index) => (
          <div key={key} onClick={handleRoute.bind(this, url)} className={`flex align-items-center patient-chart-nav-item pointer absolute min-width-260 height-56 ${selectedItem.key === key && 'selected'}`} style={{ top: index * MENU_HEIGHT }}>
            <Icon badgeCount={badgeCount} />
            <label className='color-white bold pointer'>{label}</label>
          </div>
        ))
      }
      {
        bottomItems.map(({ key, Icon, label, url, badgeCount, onRoute: handleRoute = () => {}, }, index) => (
          <div key={key} onClick={handleRoute.bind(this, url)} className={`flex align-items-center patient-chart-nav-item pointer absolute min-width-260 height-56 ${selectedItem.key === key && 'selected'}`} style={{ bottom: index * MENU_HEIGHT }}>
            <Icon badgeCount={badgeCount} />
            <label className='color-white bold pointer'>{label}</label>
          </div>
        ))
      }
    </div>
  );
}

export default NavBar;
